import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { env } from './environments/environment';

const onBootstrapAppInit = env.onBootstrapAppInit?.() ?? Promise.resolve();
onBootstrapAppInit.then(() => {
  bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
});